import { Typography } from "@mui/material";
import styles from "../SuccessPlan.module.scss";

const ContactItemViewer = ({ item }: { item: any }) => {
  const {
    decMakerName,
    decMakerTitle,
    decMakerSentiment,
    competitorDevices,
    competitorMtg,
    competitorCalling,
  } = item;

  return (
    <>
      <Typography className={styles["sp-label-gray"]}>Decision Maker Name:</Typography>
      <Typography className={styles["sp-label"]}>{decMakerName ?? "N/A"}</Typography>
      <Typography className={styles["sp-label-gray"]}>Decision Maker Title:</Typography>
      <Typography className={styles["sp-label"]}>{decMakerTitle ?? "N/A"}</Typography>

      {decMakerSentiment !== "" && (
        <>
          <Typography className={styles["sp-label-gray"]}>
            What is the decision maker sentiment?
          </Typography>
          <Typography className={styles["sp-label"]}>{decMakerSentiment ?? "N/A"}</Typography>
        </>
      )}

      {decMakerSentiment === "Advocate of Competitor" && (
        <>
          <Typography className={styles["sp-label-gray"]}>Meetings:</Typography>
          {competitorMtg && competitorMtg.length > 0 ? (
            <Typography className={styles["sp-label"]}>
              {competitorMtg.join(", ").replaceAll("%", " ")}
            </Typography>
          ) : (
            <Typography className={styles["sp-label"]}>N/A</Typography>
          )}
          <Typography className={styles["sp-label-gray"]}>Devices:</Typography>
          {competitorDevices && competitorDevices.length > 0 ? (
            <Typography className={styles["sp-label"]}>
              {competitorDevices.join(", ").replaceAll("%", " ")}
            </Typography>
          ) : (
            <Typography className={styles["sp-label"]}>N/A</Typography>
          )}
          <Typography className={styles["sp-label-gray"]}>Calling:</Typography>
          {competitorCalling && competitorCalling.length > 0 ? (
            <Typography className={styles["sp-label"]}>
              {competitorCalling.join(", ").replaceAll("%", " ")}
            </Typography>
          ) : (
            <Typography className={styles["sp-label"]}>N/A</Typography>
          )}
        </>
      )}
    </>
  );
};

export default ContactItemViewer;
